import { useThemeProvider } from '../utils/ThemeContext';

export const useTheme = () => {
  return useThemeProvider();
};

// Helper hook for theme-specific classes
export const useThemeClasses = () => {
  const { brandTheme, isDirect, isMP } = useTheme();
  
  return {
    theme: brandTheme,
    isDirect,
    isMP,
    // Background classes
    bgPrimary: 'bg-theme-primary',
    bgSecondary: 'bg-theme-secondary',
    bgAccent: 'bg-theme-accent',
    bgSurface: 'bg-theme-surface',
    bgSurfaceLight: 'bg-theme-surface-light',
    bgSurfaceAccent: 'bg-theme-surface-accent',
    // Text classes
    textPrimary: 'text-theme-primary',
    textSecondary: 'text-theme-secondary',
    textMuted: 'text-theme-muted',
    
    // Border classes
    borderPrimary: 'border-theme-primary',
    borderSecondary: 'border-theme-secondary',
    
    // Button classes
    btnPrimary: 'btn-theme-primary',
    btnSecondary: 'btn-theme-secondary',
    bgButtonPrimary: 'bg-theme-button-primary',
    bgButtonSecondary: 'bg-theme-button-secondary',
    textButtonPrimary: 'text-theme-button-primary',
    textButtonSecondary: 'text-theme-button-secondary',
    hoverButtonPrimary: 'hover:bg-theme-button-primary',
    hoverButtonSecondary: 'hover:bg-theme-button-secondary',
    
    // Direct theme specific classes
    direct: {
      bgPrimary: 'bg-direct-800',
      bgSecondary: 'bg-direct-700',
      bgAccent: 'bg-direct-600',
      bgSurface: 'bg-direct-800',
      bgSurfaceLight: 'bg-direct-700',
      bgSurfaceAccent: 'bg-direct-600',
      textPrimary: 'text-direct-100',
      textSecondary: 'text-direct-200',
    },
    
    // MP theme specific classes
    mp: {
      bgPrimary: 'bg-mp-800',
      bgSecondary: 'bg-mp-700',
      bgAccent: 'bg-mp-600',
      bgSurface: 'bg-mp-800',
      bgSurfaceLight: 'bg-mp-700',
      bgSurfaceAccent: 'bg-mp-600',
      textPrimary: 'text-mp-100',
      textSecondary: 'text-mp-200',
    }
  };
};
